import { Button, PrimaryButton } from '@library/components/buttons';
import AddWhiteIcon from '@library/assets/images/icons/add-white-icon.svg';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import { Icon } from '@library/components/icons/Icon';
import { PageTitle } from '@library/components/PageTitle';
import { Spinner } from '@library/components/Spinner';

interface UtilDashboardHeaderProps {
  children?: React.ReactNode;
  isCreateAllowed?: boolean;
  isCSVExportDisabled: boolean;
  isGeneratingCSV: boolean;
  handleCSVExportClick: () => void;
  handleCreateNewItemClick: () => void;
  pageTitle: string;
}

const UtilDashboardHeader = ({
  children = undefined,
  isCreateAllowed = false,
  isCSVExportDisabled,
  isGeneratingCSV,
  handleCSVExportClick,
  handleCreateNewItemClick,
  pageTitle
}: UtilDashboardHeaderProps) => {
  return (
    <section className="border-soFresh-140 flex w-auto justify-between gap-4 border-b px-6 pb-2 pt-3">
      <PageTitle title={pageTitle} />
      <Button
        className="border-soFresh-140 hover:bg-soFresh-120 bg-soFresh-110 disabled:bg-soFresh-130 text-soClean-140 flex items-center gap-2 rounded-md border p-3 text-sm"
        disabled={isCSVExportDisabled}
        onClick={handleCSVExportClick}
      >
        {isGeneratingCSV ? (
          <>
            <Spinner /> Exporting
          </>
        ) : (
          <>
            <ArrowUpTrayIcon className="size-5" /> Export CSV
          </>
        )}
      </Button>
      {children}
      {isCreateAllowed && (
        <PrimaryButton handleOnClick={handleCreateNewItemClick}>
          <div className="flex gap-2 text-sm">
            <Icon alt="plus" src={AddWhiteIcon} /> Add new
          </div>
        </PrimaryButton>
      )}
    </section>
  );
};

export default UtilDashboardHeader;
